import { ref, readonly, reactive } from 'vue'
import { defineStore } from 'pinia'
import { researchStatus } from '@/enums/researchStatus'
import type { iCommunityResearch } from '@/stores/communityResearch/iCommunityResearch'

export const communityResearchDraftStore = defineStore('communityResearchDraft', () => {
  const initiated = ref<boolean>(false)

  const communityResearchList = ref<iCommunityResearch[]>([])

  const getcommunityResearchList = readonly(communityResearchList)

  const isInitiated = readonly(initiated)

  function setcommunityResearchList(list: iCommunityResearch[]) {
    communityResearchList.value = list
    initiated.value = true
  }
  function addMoreommunityResearchList(list: iCommunityResearch[]) {
    communityResearchList.value = communityResearchList.value.concat(list)
  }
  function reInitiate() {
    initiated.value = false
  }

  return {
    getcommunityResearchList,
    setcommunityResearchList,
    addMoreommunityResearchList,
    isInitiated,
    reInitiate
  }
})
